import React from 'react';
import { Grid, Typography } from '@mui/material';
import { SparkScrollableGridContainer } from 'sharedComponents/UI';

export type ViewType = 'mobile' | 'desktop';
export const VIEWS: Record<string, ViewType> = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
} as const;

type PreviewContentProps = {
  children: React.ReactNode;
  selectedView: ViewType;
};

function PreviewContent({ children, selectedView }: PreviewContentProps) {
  return (
    <Grid container justifyContent='center' height='100%' marginTop={2}>
      <SparkScrollableGridContainer
        height='40rem'
        width={selectedView === VIEWS.DESKTOP ? '60rem' : '20rem'}
        borderRadius='10px'
        boxShadow={(theme) => theme.shadows[4]}
        bgcolor={(theme) => theme.palette.bgGray.main}
        headerStyle={{
          padding: 0,
          bgcolor: (theme) => theme.palette.primary.light,
          justifyContent: 'center',
        }}
        header={<Typography>sparkup.ai</Typography>}
        scrollableContainerStyle={{ padding: 0 }}
      >
        {children}
      </SparkScrollableGridContainer>
    </Grid>
  );
}

export default PreviewContent;
